import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';

type useGuestPageContentRedesignReturnType = Readonly<{
  enabled: boolean;
  loading: boolean;
}>;

export const useGuestPageContentRedesign = (): useGuestPageContentRedesignReturnType => {
  const [isEnabled, isLoading] = useIsFeatureEnabled({ eventFeatureFlagKey: 'useGuestPageContentRedesign' });

  const eventExposure = useMemo(
    () => ({
      enabled: isEnabled,
      loading: isLoading,
    }),
    [isEnabled, isLoading],
  );

  return eventExposure;
};
